'use client';

import { createClient } from '@/utils/supabase/client';
import { useTranslations } from 'next-intl';
import { TicketAllocation } from './TicketRowItem';
import DownloadButton from './DownloadButton';
import WatchButton from './WatchButton';

export default function TicketRowItemMobile(props: TicketAllocation) {
    const { ticketAllocationId, name, usage_limits, screening, ticketPath, voucher } = props;

    const t = useTranslations();
    const supabase = createClient();

    const usageLimits = Array.isArray(usage_limits)
        ? usage_limits
        : typeof usage_limits === 'string'
          ? JSON.parse(usage_limits)
          : [];

    const isOnline = screening ? screening.screening_type === 'ONLINE' : usageLimits.online;
    const isOffline = screening ? screening.screening_type === 'OFFLINE' : usageLimits.in_cinema;

    const usage = `${isOnline ? t('Cart.virtualExclusive') : ''} ${
        isOnline && isOffline ? '/' : ''
    } ${isOffline ? t('Cart.inCinema') : ''}`;

    let type = '';
    if (usageLimits.single_use === true || usageLimits.online === 1 || usageLimits.in_cinema === 1)
        type = name;
    else type = t('Common.pass');

    const downloadTicket = async (path: string) => {
        const { data } = await supabase.storage.from('tickets').download(path);
        const blob = new Blob([data as BlobPart], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = path;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="flex flex-col gap-2 py-4 border-b border-white/20 text-white text-sm">
            <div className="font-semibold uppercase">{screening ? screening.name : name}</div>

            <div className="flex justify-between text-white/70">
                <span className="uppercase">{t('Common.type')}</span>
                <span className="uppercase">{type}</span>
            </div>

            <div className="flex justify-between text-white/70">
                <span className="uppercase">{t('Common.usage')}</span>
                <span className="uppercase">{usage}</span>
            </div>

            <div className="flex gap-3 pt-2">
                {ticketPath && (
                    <DownloadButton
                        className="max-w-max"
                        onClick={() => downloadTicket(ticketPath)}
                        name={ticketPath}
                    />
                )}
                {screening && (screening.streaming_url || voucher) && (
                    <WatchButton
                        ticketAllocationId={ticketAllocationId}
                        cinesendVideoId={screening.streaming_url || ''}
                        voucherCode={voucher}
                    />
                )}
            </div>
        </div>
    );
}
